import { SubscriptionSettings } from 'components/SubscriptionSettings/api';
import { CustomerSubscription } from 'interfaces/ApiTypeAliases';
import { OdinSubscriptionDetails } from 'interfaces/odinTypes';
import {
  BroadbandSubscriptionHybridDTO,
  OfficeLicenseDTO,
  SubscribableSecurityPackagesDTO,
  WiFiBoosterEligibilityForOrderDTO,
  WiFiSettingsDTO,
} from '../types';

export const broadbandMenuDetails = {
  productType: 'Broadband',
  address: {
    street: 'Sixabcvej',
    streetNumber: '1',
    city: 'Aalborg',
    zipCode: '9000',
    level: '31',
    side: 'MF',
    houseLetter: '',
    apartmentNumber: null,
  },
  subscriptionId: 'MOCK_BROADBAND',
};

export const broadbandSubscription: OdinSubscriptionDetails = {
  accountNumber: 204045988,
  subscriptionId: 'MOCK_BROADBAND',
  paysForAccount: true,
  product: {
    groupId: 'BROADBAND',
    productName: 'Bredbånd',
    packageName: 'Bredbånd og Fastnet 50/10, DSL',
    recurringPrice: 0,
    packageRecurringPrice: 433,
    fairUseLimit: false,
    productParameters: [],
    isCollectiveOffer: false,
  },
  address: {
    street: 'Fiveabcvej',
    streetNumber: '3',
    city: 'Aalborg',
    zipCode: '9000',
    level: '38',
    side: 'MF',
    houseLetter: '',
    apartmentNumber: '',
    municipalityCode: '',
    streetCode: '',
  },
  broadbandSpeed: {
    uploadMaximumSpeed: 12288,
    uploadMinimumSpeed: 10240,
    downloadMaximumSpeed: 56320,
    downloadMinimumSpeed: 51200,
    uploadExpectedSpeed: null,
    downloadExpectedSpeed: null,
  },
  deliveryText: '',
  youseeClassicAccess: {
    username: null,
    isLoggedIn: false,
  },
  lineType: 'Dsl',
  isOfflineSubscription: false,
  encryptedRootLid: 'A3BE00135D97DC5047BA60450246EB7B',
  hasEncryptedCpr: true,
};

export const broadbandCustomerSubscription: CustomerSubscription = {
  role: {
    isPayer: true,
    isOwner: true,
    isUser: true,
    payer: '204044081',
    owner: '5772057480',
    user: '5772057480_1_1',
  },
  aggregatedRole: {
    payer: 'Full',
    owner: 'Full',
    user: 'Full',
  },
  technology: 'Copper',
  lid: 'EM127159',
  type: 'PartialSubscription',
  identifier: '4317',
  header: 'Bredbånd 20/2 Mbit',
  productCode: 'SP13_350_10',
  productType: 'Broadband',
  customerPaidAccountNumbers: ['204044081'],
  packageMeta: {
    partOfPackage: false,
    identifier: null,
    packageProductCode: null,
    packageProductName: null,
  },
  addOns: [],
  backwardsCompatibleIdentifier: {
    identifier: 'CF019B20EF0A1EFF104F64C8F6556159,SP13_350_10',
    isEnabled: true,
  },
};

export const getSubscriptionsResponse = {
  subscriptionId: '9546F74CBA5164E69EB99C34590E63B1,SP57_825_03_TV,Broadband',
  product: { productName: 'Mock data', recurringPrice: 42 },
};

export const subscriptionHybrid: BroadbandSubscriptionHybridDTO = {
  dataLimit: 50000,
  dataUsage: 10000,
};

export const allSubscriptionsSettings: SubscriptionSettings[] = [
  {
    productCode: 'AP13_950_32X',
    productName: 'Test',
    cmsRef: 'C6932000',
    subscribed: true,
    type: 'Setting',
    changeCode: null,
    orderId: null,
    orderDate: '0001-01-01T00:00:00',
    settings: [],
  },
];

export const wiFiSettings: WiFiSettingsDTO = {
  networkName: 'WiFimodem-B6A6',
  ssidCoaxPattern: '^[a-zA-Z0-9](?:[a-zA-Z0-9_-]*[a-zA-Z0-9])?$',
  ssidPattern: '^[a-zA-Z0-9](?:[a-zA-Z0-9_-]*[a-zA-Z0-9])?$',
  networkPassword: '********',
  passwordPattern: '^[A-Za-z0-9]+$',
  isWifi5gCapable: true,
  channel: 'Auto',
  channel5g: 'Auto',
  listOfChannels: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13'],
  listOfChannels5g: [
    '0',
    '36',
    '40',
    '44',
    '48',
    '52',
    '56',
    '60',
    '64',
    '100',
    '104',
    '108',
    '112',
  ],
  isConnected: true,
  usesOwnEquipment: false,
  unsupportedRouter: false,
  lineType: 'Coax',
  routerName: 'WOD02',
  coax: { isV2: false, isV3: false, isDocsis: false },
  dsl: { isHGW4: false, isHGW6: false },
  booster: { hasStarterKit: false, hasSingleKit: false },
  hasMitInternet: false,
};

export const wiFiBoosterEligibilityForOrder: WiFiBoosterEligibilityForOrderDTO = {
  eligibleForBooster: true,
  hasOpenOrder: false,
  willBeUpgradedToNewRouter: false,
  boosterCountCustomerHavingNow: 0,
  routerActAsBooster: false,
};

export const officeLicenseURL: OfficeLicenseDTO = {
  licenseUrl: 'https://www.activate-here.com',
};

export const subscribableSecurityPackages: SubscribableSecurityPackagesDTO = {
  addOnProducts: [
    {
      productCode: 'AP13_355_08',
      productName: 'YouSee Sikkerhedspakke, 5 licenser',
      cmsRef: 'C1335508',
      subscribed: false,
      recurringPrice: 29,
      billingCyclePeriod: 'Quarterly',
      addOnType: 'SecurityPackageExtra',
      oneTimePrice: 0,
      changePrice: 0,
      changeCode: null,
      orderDate: '0001-01-01T00:00:00',
      addOnProducts: [],
      electronicDelivery: false,
    },
    {
      productCode: 'AP13_355_09',
      productName: 'YouSee Sikkerhedspakke, 10 licenser',
      cmsRef: 'C1335509',
      subscribed: false,
      recurringPrice: 39,
      billingCyclePeriod: 'Quarterly',
      addOnType: 'SecurityPackageExtra',
      oneTimePrice: 0,
      changePrice: 0,
      changeCode: null,
      orderDate: '0001-01-01T00:00:00',
      addOnProducts: [],
      electronicDelivery: false,
    },
    {
      productCode: 'AP13_355_10',
      productName: 'YouSee Sikkerhedspakke, 15 licenser',
      cmsRef: 'C1335510',
      subscribed: false,
      recurringPrice: 49,
      billingCyclePeriod: 'Quarterly',
      addOnType: 'SecurityPackageExtra',
      oneTimePrice: 0,
      changePrice: 0,
      changeCode: null,
      orderDate: '0001-01-01T00:00:00',
      addOnProducts: [],
      electronicDelivery: false,
    },
    {
      productCode: 'AP13_355_11',
      productName: 'YouSee Sikkerhedspakke, 20 licenser',
      cmsRef: 'C1335511',
      subscribed: false,
      recurringPrice: 59,
      billingCyclePeriod: 'Quarterly',
      addOnType: 'SecurityPackageExtra',
      oneTimePrice: 0,
      changePrice: 0,
      changeCode: null,
      orderDate: '0001-01-01T00:00:00',
      addOnProducts: [],
      electronicDelivery: false,
    },
    {
      productCode: 'AP04_620_09',
      productName: 'YouSee Sikkerhedspakke 3 licenser',
      cmsRef: 'C0462009',
      subscribed: true,
      recurringPrice: 0,
      billingCyclePeriod: 'Quarterly',
      addOnType: 'SecurityPackageExtra',
      oneTimePrice: 0,
      changePrice: 0,
      changeCode: null,
      orderDate: '0001-01-01T00:00:00',
      addOnProducts: [],
      electronicDelivery: false,
    },
  ],
  osmMail: 'pgr@tdc.dk',
};
